import { useOperatorSearchApi, useOperatorSearchCondition } from '@/common/api/modules/operator'
import { useFirstLoading } from '@/common/api/search'
import { operatorNewPath } from '@/common/app/path'

import Button, { ButtonColor } from '@/components/view/atoms/button/Button'
import Area from '@/components/view/layouts/area/Area'
import Content from '@/components/view/layouts/page/Content'
import Main, { MainLayoutType } from '@/components/view/layouts/page/Main'
import PageListLoading from '@/components/view/molecules/loading/PageListLoading'
import PageListSearching from '@/components/view/molecules/loading/PageListSearching'
import NoResultGuidance from '@/components/view/molecules/search/NoResultGuidance'
import PageTitle from '@/components/view/molecules/title/PageTitle'

import OperatorListTable from '@/components/container/modules/admin/operator/table/OperatorListTable'
import TitlePageInfo from '@/components/container/utils/pager/TitlePageInfo'

const OperatorListPage = () => {
  const [condition, setCondition, onUpdatePage] = useOperatorSearchCondition()
  const { data, isLoading } = useOperatorSearchApi(condition)

  const isFirstLoading = useFirstLoading(isLoading)

  return (
    <Main type={MainLayoutType.SMALL} bottomSpace>
      <PageTitle
        title={'オペレーター管理'}
        description='W2オペレーターの一覧'
        behindNode={
          data && (
            <TitlePageInfo
              page={condition.page}
              perPage={condition.perPage}
              total={data.length}
              unit={'件'}
            />
          )
        }
        rightNode={
          <Button link={operatorNewPath()} size='large' color={ButtonColor.PRIMARY_BRAND}>
            新規オペレーターを追加する
          </Button>
        }
      />
      <Content>
        {isFirstLoading ? (
          <PageListLoading />
        ) : (
          <Area tableWrap noBorder>
            {isLoading ? (
              <PageListSearching />
            ) : data ? (
              <OperatorListTable
                operators={data}
                onUpdatePage={onUpdatePage}
                total={data.length}
                condition={condition}
                setCondition={setCondition}
              />
            ) : (
              <NoResultGuidance searched name='オペレーター' />
            )}
          </Area>
        )}
      </Content>
    </Main>
  )
}

export default OperatorListPage
